import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'
import { ReactNode, useCallback, useState } from 'react'
import { fetchBillingPortalSession } from '@/actions/settings/billingActions'
import { useAppDispatch } from '@/utils/typeHelpers'
import { ANNUAL_TAX_RETURNS_FED_AND_STATE_VALUE_IN_DOLLARS } from '@/constants/businessConstants'
import { Button, Text, Icon, List, Dialog } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'
import { selectPlanNameOrBasic } from '@/reducers/subscription.slice'
import { useReselector } from '@/utils/sharedHooks'

const Perk = ({ children }: { children: ReactNode }) => (
  <List.Item className="py-2 flex items-center">
    <Icon color="green" icon={regular('check')} className="mr-2" />
    {children}
  </List.Item>
)

export const AnnualTaxesContent = () => {
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(false)
  const planName = useReselector(selectPlanNameOrBasic)

  const redirectToStripePortal = useCallback(async () => {
    setLoading(true)
    const res = await fetchBillingPortalSession()(dispatch)
    if (res) {
      window.location.href = res.url
    }
    setLoading(false)
  }, [dispatch])

  return (
    <Dialog open>
      <Dialog.Content className="bg-orange-0 p-0 max-w-[1000px]">
        <div className="flex flex-col p-10">
          <div className="mb-4">
            <Text
              variant={TypographyStyles.DISPLAY_LG}
              className="flex items-center"
              color={TextColors.BRAND}
            >
              Annual Taxes
              <Icon
                size="xs"
                className="ml-8 h-6 w-6"
                icon={regular('lock')}
                color={TextColors.BRAND}
              />
            </Text>
          </div>
          <div className="flex flex-row pb-10">
            <div className="w-1/2 pr-4">
              <Text variant={TypographyStyles.BODY_MD}>
                Heard&apos;s annual tax service guides you through the tax
                filing process by seamlessly integrating with bookkeeping to
                ensure you&apos;re maximizing your deductible expenses on your
                tax returns. Our team of third-party tax preparers files your
                annual tax returns for both federal and state (a $
                {ANNUAL_TAX_RETURNS_FED_AND_STATE_VALUE_IN_DOLLARS} value).
              </Text>
              <br />
              <List>
                <Perk>
                  <Text variant={TypographyStyles.BODY_MD}>
                    Personalized preparation of your annual tax returns for you
                  </Text>
                </Perk>
                <Perk>
                  <Text variant={TypographyStyles.BODY_MD}>
                    Annual federal and state taxes filed for you
                  </Text>
                </Perk>
                <Perk>
                  <Text variant={TypographyStyles.BODY_MD}>
                    Upload your receipts directly into Heard
                  </Text>
                </Perk>
                <Perk>
                  <Text variant={TypographyStyles.BODY_MD}>
                    Unlimited messaging with tax preparer
                  </Text>
                </Perk>
              </List>
            </div>
            <div className="w-1/2 pl-4">
              <img
                src="https://heard-images.s3.amazonaws.com/assets/annual-tax-teaser-cards.png"
                alt="Annual Tax Teaser"
              />
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-between items-center bg-moss-100 m-0 p-10 w-full rounded-b-xl">
          <div className="flex-1" style={{ flexBasis: '70%' }}>
            <Text variant={TypographyStyles.LABEL_LG} color={TextColors.WHITE}>
              You&apos;re currently on a {planName} Subscription Plan
            </Text>
          </div>
          <div className="flex-1">
            <Button
              onClick={redirectToStripePortal}
              loading={loading}
              variant="primary"
              size="lg"
              className="w-full"
            >
              Upgrade to Pro Plan
            </Button>
          </div>
        </div>
      </Dialog.Content>
    </Dialog>
  )
}
